// 导出该模块 state、actions、mutations
import actions from './actions'
import npsStrategy from './metaData/npsStrategy'
export default {
  state: npsStrategy,
  actions
}
